import { validateEnumTranslations } from '../../safety_checks';
import { ActivityRecommendationSource } from '../activity/activity.schema';

/**
 * Source de la recommandation d'activité au picker — utilisée par le frontend
 * pour adapter le wording du header ("Recommandé pour vous", "Top de la
 * catégorie", "Activités populaires").
 *
 * Cf. docs/professional-activities-plan.md §6.1 (logique `/recommend`).
 */

export const ACTIVITY_RECOMMENDATION_SOURCE_TRANSLATE_KEY = 'ACTIVITY_RECOMMENDATION_SOURCE_';

export const ActivityRecommendationSourceTranslation = {
  'fr-FR': {
    [`${ACTIVITY_RECOMMENDATION_SOURCE_TRANSLATE_KEY}${ActivityRecommendationSource.FUZZY_MATCH}`]:
      'Recommandé pour vous',
    [`${ACTIVITY_RECOMMENDATION_SOURCE_TRANSLATE_KEY}${ActivityRecommendationSource.SECTOR_TOP}`]:
      'Top de la catégorie',
    [`${ACTIVITY_RECOMMENDATION_SOURCE_TRANSLATE_KEY}${ActivityRecommendationSource.GLOBAL_TOP}`]:
      'Activités populaires',
  },
};

validateEnumTranslations(
  ActivityRecommendationSource,
  ActivityRecommendationSourceTranslation,
  ACTIVITY_RECOMMENDATION_SOURCE_TRANSLATE_KEY,
  true,
);
